export default __webpack_public_path__ + "static/media/facebook.94361eae.svg";